import axios from "axios";
import { SelectFormat } from "../../../rbts/helpers/models/GenericModel";
import { PuntoVentaModel } from "../../pages/start_shift/models/StartShiftModel";
const API_URL = process.env.REACT_APP_API;

export async function getAllShiftSupplier() {
  const response = await axios.get(`${API_URL}puntoVenta/diaVenta/list`);
  const data = response.data.doc.data;
  return data;
}
export async function startDaySupplier(supplierId: number) {
  const response = await axios.post(
    `${API_URL}puntoVenta/iniciarDia/${supplierId}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getAllSuppliersClosed() {
  const response = await axios.get(
    `${API_URL}puntoVenta/diaVenta/list?isOpen=false`
  );
  const data = response.data.doc.data.rows;
  let select: SelectFormat[] = [];
  data.forEach((item: any) => {
    const selectCustom = {
      id: Number(item.id),
      value: item.id_punto_venta,
      label: `${item.nombre_punto_venta}`,
      data: item,
    };
    select.push(selectCustom);
  });

  return select;
}
export async function crearPuntoVentaService(evento: PuntoVentaModel) {
  try {
    const { id, nombre, banco, punto_venta, productos, is_supply_available } = evento;
    let url = `${API_URL}/puntoVenta/init/database`;

    if(id){
      url = `${API_URL}/puntoVenta/${id}`;
    }
    
    const response = id
      ? await axios.patch(url, { 
        nombre: nombre,
        tipo: 'PUESTO',
        is_supply_available: is_supply_available,
        split: {
          porcentaje_banco: banco,
          porcentaje_punto_venta: punto_venta
        },
        productos: productos
       })
      : await axios.post(url, { 
        nombre: nombre,
        is_supply_available: is_supply_available,
        tipo: 'PUESTO',
        split: {
          banco: banco,
          punto_venta: punto_venta
        },
        productos: productos
       });
    
    return response;
  } catch (error) {
    console.error('Error en crearPuntoVentaService:', error);
    throw error;
  }
}

export async function obtenerPVPorIDService(id: number) {
  try {
    const response = await axios.get(`${API_URL}/productosPuntoVenta/productos/${id}`);
    let punto_venta = response.data.doc.data[0];

    if (!punto_venta) {
      throw new Error("No se encontró el punto de venta");
    }
    const { nombre, convenioSplit, productos, is_supply_available } = punto_venta;

    let newProductos = productos.map((item: any) => {
      const through = item.productos_punto_venta ?? {};
      return {
        id: item.id,
        nombre: item.nombre,
        precio_venta: item.costo_sugerido,
        aplica_costo_fijo_cortesia: through.aplica_costo_fijo_cortesia || false,
        costo_fijo_cortesia: through.costo_fijo_cortesia || 0,
        isNew: false,
      };
    });
    const initModel: PuntoVentaModel = {
      id: id,
      nombre: nombre,
      banco: convenioSplit ? convenioSplit.porcentaje_banco : 0,
      punto_venta: convenioSplit ? convenioSplit.porcentaje_punto_venta : 100,
      productos: newProductos,
      is_supply_available: is_supply_available,
    };
    return initModel;
  } catch (error) {
    console.log("ERROR: ", error);
    throw error;
  }
}

export async function getAllPuntosVenta() {
  try {
    const response = await axios.get(`${API_URL}puntoVenta/`);
    const data = response.data.doc.data;
    return data;
  } catch (error) {
    console.log("ERROR: ", error);
    throw error;
  }
}

export async function eliminarPuntoVentaService(id: number) {
  const response = await axios.delete(`${API_URL}puntoVenta/${id}`);
  return response.data;
}

export async function eliminarPVDiaVentaService(id: number) {
  const response = await axios.delete(`${API_URL}puntoVenta/diaVenta/${id}`);
  return response.data;
}
